import graphql__10dce53f3870f09f2d59 from "./__generated__/ContributionOverviewModal_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../Intl/Context";
import Modal from "../../Modals/Modal";
import { isAuthorized } from "../../Utils/authorizations";
import { useRoutesContext } from "../../Routes/RoutesContext";
import ButtonLink from "../../Buttons/ButtonLink";
import AnswerPreviewPages from "../../AnswerPreview/AnswerPreviewPages";

const ContributionOverviewModal = props => {
  const contribution = useFragment(
    ContributionOverviewModal_contribution,
    props.contribution
  );

  const { title, slug: contributionSlug, allAnswers: answers } = contribution;

  const { editContribution } = contribution.authorizations;

  const { slug: participativeModuleSlug } = contribution.participativeModule;

  const t = useFormatMessage();
  const labels = {
    editContribution: t(intlMessages.editContribution)
  };

  const { pathFor } = useRoutesContext();
  const editContributionPath = pathFor("editContribution", {
    participativeModuleSlug,
    contributionSlug
  });

  return (
    <Modal
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      className="contribution-modal"
      title={title}
      displayTitle={false}
    >
      <div className="modal-form-title margin-bottom-xs box d-flex flex-row align-items-center">
        <h1 className="modal-form-title-text text-title-page flex-1">{title}</h1>

        {isAuthorized(editContribution) && (
          <ButtonLink
            type="button"
            href={editContributionPath}
            className="btn btn-primary-inverse btn-shadow btn-sm"
            iconClassName="icon-pencil"
            label={labels.editContribution}
          />
        )}
      </div>

      <AnswerPreviewPages answers={answers} />
    </Modal>
  );
};

export default ContributionOverviewModal;

const ContributionOverviewModal_contribution = graphql__10dce53f3870f09f2d59;

const intlMessages = defineMessages({
  editContribution: {
    id: "contribution.card.editContribution",
    defaultMessage: "Modifier la contribution"
  }
});
